import React from 'react';

const MongoDB_Certificate = () => {
  return (
    <div>
      <h1>MongoDB_Certificate Component</h1>
      <p>This is the MongoDB_Certificate page.</p>
    </div>
  );
};

export default MongoDB_Certificate;
